import VFocus from "@/directives/VFocus";
import Scroll from "@/directives/Scroll";
import ScrollNew from "@/directives/Scroll_new";


export default [
    VFocus, Scroll, ScrollNew
]